<template>
  <section class="user-analytics">
    <div class="box-header">
      <Search width="35%" height="40px" border-radius="3px" background-color="#FFFFFF" />
      <div class="box-right">
        <Select />
        <Button :icon="{
                  type: 'file-text',
                  size: '14px',
                  color: '#219653',
                }"
                title="Exportar"
                border-radius="3px"
                height="40px"
                border-width="1px"
                border-color="#FFF"
                margin-right="10px"
        />
        <Button :icon="{
                  type: 'filter',
                  size: '14px',
                  color: '#219653',
                }"
                border-radius="3px"
                border-width="1px"
                border-color="#FFF"
                height="40px"
        />
      </div>
    </div>
    <div class="box-table-actions">
      <div class="">
        <span>Foram encontrados </span><span class="strong-text_green">291,000</span><span> registros</span>
      </div>
      <div class="right_container">
        <div class="filter-container__ordernation">
          <span>Ordernar por </span>
          <span class="strong-text_green">Data</span>
        </div>
        <div class="container-select__box">
          <svg class="list-container-box" width="19" height="17" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.125 1H12.25" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.125 4.75H12.25" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.125 8.5H12.25" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 1H1.00625" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 4.75H1.00625" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 8.5H1.00625" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <svg width="15" height="15" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="4.16667" height="4.16667" rx="1" fill="#219653" />
            <rect x="5.83331" width="4.16667" height="4.16667" rx="1" fill="#219653" />
            <rect x="5.83331" y="6.66666" width="4.16667" height="4.16667" rx="1" fill="#219653" />
            <rect y="6.66666" width="4.16667" height="4.16667" rx="1" fill="#219653" />
          </svg>
        </div>
      </div>
    </div>
    <div class="boxes-table__cards">
      <User @click="goToUser($event)" />
      <User />
      <User />
      <User />
      <User />
      <User />
      <User />
      <User />
    </div>
  </section>
</template>

<script>
import Search from '../../../layout/components/search/custom';
import Button from '../../../layout/components/buttons/Default';
import Select from '../../../layout/components/select/Default';
import User from '../../../layout/components/cards/User';

export default {
	components: {
		Search,
		Select,
		Button,
		User,
	},
	methods: {
		goToUser(id) {
			this.$router.push(`empresas/detalhes/${id}`);
		}
	}
};
</script>

<style scoped>

.boxes-table__cards {
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.container-select__box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.right_container {
  display: flex;
}

.list-container-box {
   margin-right: 10px;
}
.filter-container__ordernation {
  margin-right: 20px;
}
.box-header {
    width: 100%;
    margin-top: 20px;
    display: flex;
        align-items: flex-start;
    justify-content: space-between;
}
.strong-text_green {
  font-weight: bold;
  color: #219653;
}
.user-analytics {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.box-right {
  display: flex;
}

.box-table-actions {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>
